export default __webpack_public_path__ + "static/media/DSC06008.2da1f53c.jpg";